import React, { useEffect, useState } from "react";
import { updateSGloopUserMembership } from "../../services/firestore/SGloopService";
import { useAuth } from "../../context/AuthContext";

export default function NewMembershipModal({ isOpen, onClose, selectedGroups }) {
  const [formData, setFormData] = useState({}); // main form state
  const { userData, userRef } = useAuth();
  

  // Initialize form data from config
  useEffect(() => {
    if (!selectedGroups?.MembershipForm) return;

    const initialData = {};
    selectedGroups.MembershipForm.forEach((field) => {
      if (typeof field === "string") {
        initialData[field] = "";
      } else if (field.Repeatable && field.Fields) {
        initialData[field.Repeatable] = [
          field.Fields.reduce((acc, f) => ({ ...acc, [f]: "" }), {})
        ]; // start with one repeatable
      }
    });

    setFormData(initialData);
  }, [selectedGroups]);

  // Handle normal field changes
  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle repeatable field changes
  const handleRepeatableChange = (section, index, field, value) => {
    const updatedSection = [...formData[section]];
    updatedSection[index][field] = value;
    setFormData((prev) => ({ ...prev, [section]: updatedSection }));
  };

  // Add repeatable item
  const addRepeatable = (section, fields) => {
    const newItem = fields.reduce((acc, f) => ({ ...acc, [f]: "" }), {});
    setFormData((prev) => ({ ...prev, [section]: [...prev[section], newItem] }));
  };

  // Remove repeatable item
  const removeRepeatable = (section, index) => {
    const updated = formData[section].filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, [section]: updated }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("Form Data:", formData);

  try {
    await updateSGloopUserMembership(userRef, selectedGroups, formData);
    console.log("Membership saved successfully!");
    onClose();
  } catch (err) {
    console.error("Error saving membership:", err);
    // Optionally show an error message to the user
  }
};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-3xl p-6 max-h-[90vh] overflow-y-auto">

        <h2 className="text-2xl font-semibold mb-4 text-center">New Membership Form</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {selectedGroups.MembershipForm.map((field, idx) => {
            // Normal field
            if (typeof field === "string") {
              return (
                <div key={idx}>
                  <label className="block text-sm font-medium">{field}</label>
                  <input
                    type="text"
                    value={formData[field] || ""}
                    onChange={(e) => handleChange(field, e.target.value)}
                    className="w-full border rounded-md p-2 mt-1"
                    required
                  />
                </div>
              );
            }

            // Repeatable field
            if (field.Repeatable && field.Fields) {
              const section = field.Repeatable;
              return (
                <div key={idx} className="border-t pt-4">
                  <h3 className="text-lg font-medium mb-2">{section}</h3>
                  {formData[section]?.map((item, i) => (
                    <div key={i} className="border rounded-lg p-3 mb-3 relative">
                      {field.Fields.map((f) => (
                        <div key={f} className="mb-2">
                          <label className="block text-sm font-medium">{f}</label>
                          <input
                            type={f.includes("Age") ? "number" : "text"}
                            value={item[f] || ""}
                            onChange={(e) => handleRepeatableChange(section, i, f, e.target.value)}
                            className="w-full border rounded-md p-2 mt-1"
                            required
                          />
                        </div>
                      ))}
                      {formData[section].length > 1 && (
                        <button
                          type="button"
                          onClick={() => removeRepeatable(section, i)}
                          className="absolute top-2 right-2 text-red-500 text-sm"
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => addRepeatable(section, field.Fields)}
                    className="text-blue-600 text-sm mt-2 hover:underline"
                  >
                    + Add Another {section.slice(0, -1)}
                  </button>
                </div>
              );
            }

            return null;
          })}

          <div className="flex justify-end space-x-3 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
